// ============================================
// SERVICE D'AUTHENTIFICATION
// ============================================

import api from './api';

const authService = {
    // Inscription
    register: async (userData) => {
        try {
            const response = await api.post('/api/auth/register', userData);
            
            if (response.data.success) {
                // Stocker le token et les infos utilisateur
                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.data.user));
            }
            
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de l\'inscription' };
        }
    },

    // Connexion
    login: async (email, password) => {
        try {
            const response = await api.post('/api/auth/login', { email, password });
            
            if (response.data.success) {
                // Stocker le token et les infos utilisateur
                localStorage.setItem('token', response.data.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.data.user));
            }
            
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la connexion' };
        }
    },

    // Déconnexion
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
    },

    // Obtenir l'utilisateur actuel
    getCurrentUser: () => {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    },

    // Vérifier si l'utilisateur est connecté
    isAuthenticated: () => {
        return !!localStorage.getItem('token');
    },

    // Obtenir le token
    getToken: () => {
        return localStorage.getItem('token');
    },

    // Obtenir le profil utilisateur depuis l'API
    getProfile: async () => {
        try {
            const response = await api.get('/api/auth/me');
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Erreur lors de la récupération du profil' };
        }
    }
};

export default authService;

